import { render, staticRenderFns } from "./AskReworkPropsWindow.vue?vue&type=template&id=2b7addae&scoped=true&"
import script from "./AskReworkPropsWindow.vue?vue&type=script&lang=js&"
export * from "./AskReworkPropsWindow.vue?vue&type=script&lang=js&"
import style0 from "./AskReworkPropsWindow.vue?vue&type=style&index=0&id=2b7addae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7addae",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QInnerLoading,QSpinnerGears,QItem,QInput,QSeparator,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QInnerLoading,QSpinnerGears,QItem,QInput,QSeparator,QCardActions,QBtn}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
